import { styled } from "@pigment-css/react";
import { glassCapsulePress } from "@acto/taskpane/field-sales-2/styles/glassCapsulePress";

/**
 * Glass-capsule action button: glassMedium fill, glass shadow, and the shared
 * lift/press interaction. Hug-width by default; extend with `styled(GlassButton)`
 * for full-width or alternate typography.
 */
export const GlassButton = styled("button")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.fieldSalesTwo.spacing[8],
  padding: `${theme.fieldSalesTwo.spacing[16]} ${theme.fieldSalesTwo.spacing[20]}`,
  border: `${theme.strokeWidth.thin} solid ${theme.fieldSalesTwo.colors.surface.glassBorderStrong}`,
  borderRadius: theme.fieldSalesTwo.radius.circular,
  background: theme.fieldSalesTwo.colors.surface.glassMedium,
  boxShadow: theme.fieldSalesTwo.shadows.glass,
  backdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  WebkitBackdropFilter: `blur(${theme.fieldSalesTwo.effects.blurSm})`,
  cursor: "pointer",
  appearance: "none",
  WebkitAppearance: "none",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[900],
  whiteSpace: "nowrap",
  ...glassCapsulePress(theme, { restShadow: theme.fieldSalesTwo.shadows.glass }),
  "&:disabled": {
    opacity: 0.5,
    pointerEvents: "none",
  },
}));
